import { getPersistedExperimentTreatment } from '@ms/yammer-data/dist/domains/experiments/selectors';
import { Experiment } from '@ms/yammer-data/dist/state/types';
import { configureTelemetry } from '@ms/yammer-data/dist/telemetry';
import getClientContext from '@ms/yammer-web-support/dist/clientContext';
import { readHostingConfiguration } from '@ms/yammer-web-support/dist/hosting';
import { getHostMetadata } from '@ms/yammer-web-support/dist/metaOsHub';

import { persistConfig } from '../../persistedState';

import { getConfig } from './getConfig';

type SetupTelemetry = (options?: { readonly skipNextCleanup?: boolean }) => Promise<void>;
export const setupTelemetry: SetupTelemetry = async (options) => {
  const config = await getConfig();
  const { hostSessionId, hostAppName, hostClientType } = await getHostMetadata();

  const shouldLogProtobufEventsToConsole = (await getPersistedExperimentTreatment(
    persistConfig.key,
    Experiment.LogProtobufEvents
  )) as boolean;

  configureTelemetry({
    config,
    hostingConfig: readHostingConfiguration(),
    registerUnhandledEventsListener: true,
    clientContext: getClientContext({
      hostSessionId,
      hostAppName,
      hostClientType,
    }),
    shouldLogProtobufEventsToConsole,
    ...options,
  });
};
